(function () {
    "use strict";

    angular.module("app").component("cisTypesView", {
        template: `
            <div class="row">
                <div class="col-lg-2"><label i18n="CIS_Types_Label"></label></div>
                <div class="col-lg-4">
                    <span class="badge" ng-repeat="type in $ctrl.cis.Types">{{type | codeValue:'codeCisTypes'}}</span>
                </div>
                <div class="col-lg-6">
                    <span style="white-space: pre-wrap">{{$ctrl.cis.TypeExplanation}}</span>
                </div>
            </div>`,
        bindings: {
            cis: "<",
        },
    });

})();
